var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.campaigns),function(campaign,k){return _c('div',{key:k},[_c('div',{attrs:{"id":'campaign_' + campaign.id,"bzb-track-category":"Rewards","bzb-track-action":"View rewards","bzb-track-label":campaign.id + '|' + campaign.name}},[_vm._v(" "+_vm._s(campaign.name)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }